/**
 * ProductOrderListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
  ModalLayout,
  Descriptions,
} from 'components';
import {
  Avatar,
  Button,
  DatePicker,
  Input,
  Radio,
  Select,
  Tag,
  Pagination,
} from 'antd';
import { ProductSearch } from './components';
import { styles } from './styles';

const ProductOrderListPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    modal,
    users,
    grades,
    page,
    count,
    expand,
    onUpdateQuery,
    onChange,
    searchInputValue,
    onSubmit,
    onSearch,
    parameter,
    navigate,
    onUsedCoupon,
  } = props;
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */

  // 임시 tableData 생성
  const tableData = [
    {
      companyName: 'ABC커피',
      order_Date: '2025-01-01',
      category: '원두1',
      orderNumber: 'ORD123456',
      productName: '싱글 콜롬비아 산 세바스티안 200g',
    },
    {
      companyName: 'XYZ원두',
      order_Date: '2024-07-20',
      category: '원두2',
      orderNumber: 'ORD654321',
      productName: '스트라다 200g',
    },
    {
      companyName: 'LMN 상점',
      order_Date: '2024-05-14',
      category: '원두1',
      orderNumber: 'ORD789123',
      productName: '싱글 콜롬비아 산 세바스티안 200g',
    },
    {
      companyName: 'OPQ 도매',
      order_Date: '2024-03-03',
      category: '원두2',
      orderNumber: 'ORD321987',
      productName: '스트라다 200g',
    },
    {
      companyName: 'EFG 리테일',
      order_Date: '2024-02-22',
      category: '원두1',
      orderNumber: 'ORD456789',
      productName: '싱글 콜롬비아 산 세바스티안 200g',
    },
  ];

  // 테이블 컴포넌트에 전달할 columns
  const columns = [
    {
      title: '업체명',
      key: 'companyName',
    },
    {
      title: '발주일',
      key: 'order_Date',
    },
    {
      title: '카테고리',
      key: 'category',
    },
    {
      title: '주문번호',
      key: 'orderNumber',
    },
    {
      title: '상품명',
      key: 'productName',
    },
  ];
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>발주 목록</Title>
          <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
            {/* 검색필터 */}
            <ProductSearch />
            {/* 검색필터 */}

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
                marginBottom: 40,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                }}
                //onClick={() => onSearch()}
              >
                검색
              </Button>
              <Button
                size="large"
                style={{ ...styles.button }}
                onClick={() => navigate('/product-order/list')}
              >
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}

            {/* 검색결과 */}
            <Content maxWidth={'100%'} borderRadius={4} padding={20}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <h4
                    style={{
                      fontSize: 14,
                      fontWeight: 500,
                      marginRight: 20,
                    }}
                  >
                    검색 결과 총{' '}
                    <span>
                      {/* {users?.length} */}
                      {tableData.length}
                    </span>
                    건
                  </h4>
                  <Button size="large" style={{ marginRight: 8 }}>
                    엑셀다운로드
                  </Button>
                </div>
                <div>
                  <Select
                    value={Number(count)}
                    options={[
                      { label: '10 / page', value: 10 },
                      { label: '30 / page', value: 30 },
                      { label: '50 / page', value: 50 },
                      { label: '100 / page', value: 100 },
                    ]}
                    onChange={(e) => onUpdateQuery('count', e)}
                  />
                </div>
              </div>
              <Table data={tableData} columns={columns} />
              <Pagination
                total={tableData.length}
                //total={users?.length}
                align="center"
                style={{
                  marginTop: 40,
                  display: 'flex',
                  justifyContent: 'center',
                }}
                current={page}
                pageSize={count}
                onChange={(p) => onUpdateQuery('page', p)}
              />
            </Content>
            {/* 검색결과 끝 */}
          </Content>
        </Col>
      </Row>
    </Content>
  );
};

export default ProductOrderListPresenter;
